export const getLanguage = (language: string|null) => {
  if (!language) {
    return 'en'
  }
  if (language.startsWith('sv')) {
    return 'sv'
  }
  return 'en'
}